// extracted by mini-css-extract-plugin
module.exports = {"tabsDiv":"filter-tabs_tabsDiv__2PJt5"};